export default "__VITE_ASSET__JV_n5jPb__"